import { find, get, set } from 'lodash';
import { select, take } from 'redux-saga/effects';

import { FIELD_PATHS, REDUX_STORE } from '@funnels/constants';
import { Asset, ReduxStoreData, RelatedParty, StoreApplicant, StoreEmployment } from '@funnels/types';

export function* getRelatedPartyId(clientId: string, id?: string): any {
  if (!id) {
    const reduxStoreRelatedParties: RelatedParty[] = yield select(
      ({ relatedParties: { data } }: ReduxStoreData) => data
    );
    const relatedParty = find(reduxStoreRelatedParties, { clientId });

    if (relatedParty?.id) {
      return relatedParty.id;
    }
  }
  while (!id) {
    const action = yield take([
      REDUX_STORE.RELATED_PARTY.ACTION_TYPES.CREATE_RELATED_PARTY_FAIL,
      REDUX_STORE.RELATED_PARTY.ACTION_TYPES.CREATE_RELATED_PARTY_SUCCESS,
    ]);
    if (action.clientId === clientId) {
      // Create failed, return undefined
      if (action.type === REDUX_STORE.RELATED_PARTY.ACTION_TYPES.CREATE_RELATED_PARTY_FAIL) {
        return;
      }
      id = action.id;
    }
  }
  return id;
}

export function fixRelatedPartyForeignIds(
  clientRelatedParty: RelatedParty,
  reduxStoreApplicants: StoreApplicant[],
  reduxStoreEmployments: StoreEmployment[],
  reduxStoreAssets: Asset[]
) {
  const applicantId = get({ relatedParties: [clientRelatedParty] }, FIELD_PATHS.RELATED_PARTY_APPLICANT_ID(0));
  const employmentId = get({ relatedParties: [clientRelatedParty] }, FIELD_PATHS.RELATED_PARTY_EMPLOYMENT_ID(0));
  const assetId = get({ relatedParties: [clientRelatedParty] }, FIELD_PATHS.RELATED_PARTY_ASSET_ID(0));

  const applicantClientId = get(
    { relatedParties: [clientRelatedParty] },
    FIELD_PATHS.RELATED_PARTY_APPLICANT_CLIENT_ID(0)
  );
  const trustApplicantClientId = get(
    { relatedParties: [clientRelatedParty] },
    FIELD_PATHS.RELATED_PARTY_TRUST_APPLICANT_CLIENT_ID(0)
  );
  const companyApplicantClientId = get(
    { relatedParties: [clientRelatedParty] },
    FIELD_PATHS.RELATED_PARTY_COMPANY_APPLICANT_CLIENT_ID(0)
  );

  if (!!applicantId) {
    const storeApplicantId = reduxStoreApplicants.find((a) => a.clientId === applicantId)?.id;
    if (!!storeApplicantId && storeApplicantId !== applicantId) {
      set({ relatedParties: [clientRelatedParty] }, FIELD_PATHS.RELATED_PARTY_APPLICANT_ID(0), storeApplicantId);
    }
  }

  if (!!employmentId) {
    const storeEmploymentId = reduxStoreEmployments.find((e) => e.clientId === employmentId)?.id;
    if (!!storeEmploymentId && storeEmploymentId !== employmentId) {
      set({ relatedParties: [clientRelatedParty] }, FIELD_PATHS.RELATED_PARTY_EMPLOYMENT_ID(0), storeEmploymentId);
    }
  }

  if (!!assetId) {
    const storeAssetId = reduxStoreAssets.find((a) => a.clientId === assetId)?.id;
    if (!!storeAssetId && storeAssetId !== assetId) {
      set({ relatedParties: [clientRelatedParty] }, FIELD_PATHS.RELATED_PARTY_ASSET_ID(0), storeAssetId);
    }
  }

  if (!!applicantClientId) {
    const storeApplicantId = reduxStoreApplicants.find((a) => a.clientId === applicantClientId)?.id;
    if (!!storeApplicantId) {
      set({ relatedParties: [clientRelatedParty] }, FIELD_PATHS.RELATED_PARTY_APPLICANT_ID(0), storeApplicantId);
    }
  }

  if (!!trustApplicantClientId) {
    const storeApplicantId = reduxStoreApplicants.find((a) => a.clientId === trustApplicantClientId)?.id;
    if (!!storeApplicantId) {
      set({ relatedParties: [clientRelatedParty] }, FIELD_PATHS.RELATED_PARTY_TRUST_APPLICANT_ID(0), storeApplicantId);
    }
  }

  if (!!companyApplicantClientId) {
    const storeApplicantId = reduxStoreApplicants.find((a) => a.clientId === companyApplicantClientId)?.id;
    if (!!storeApplicantId) {
      set(
        { relatedParties: [clientRelatedParty] },
        FIELD_PATHS.RELATED_PARTY_COMPANY_APPLICANT_ID(0),
        storeApplicantId
      );
    }
  }
}
